export default __webpack_public_path__ + "static/media/hasay1.81717736.jpg";